





































































































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { formatDate } from "@/lib/date";
import { prepareMoney } from "@/assets/scripts/utils";
import { DocumentsByContract } from "@/models/contract";
import XDataTable from "../hoc/Table.vue";
import XDropdownWithDatePicker from "../hoc/DropdownWithDatePicker.vue";
import XDropdownWithRadioButtons from "../hoc/DropdownWithRadioButtons.vue";
import ActionDropdown from "../ActionDropdown.vue";
import XButton from "../SimpleButton.vue";
import moment from "moment";
import appApi from "@/assets/scripts/app-api";

@Component({
  components: {
    XDataTable,
    XDropdownWithDatePicker,
    XDropdownWithRadioButtons,
    ActionDropdown,
    XButton,
  },
  computed: {
    ...mapState({ appEnviroment: "appEnviroment" }),
    ...mapGetters({ contractId: "contract/id" }),
  },
  filters: {
    formatDate(value: string): string {
      return formatDate(value, "full");
    },
    prepareMoney,
  },
})
class DocumentTable extends Vue {
  [x: string]: any;

  @Prop({ required: true }) readonly documents!: DocumentsByContract[];

  headers = [
    { text: "Документ", value: "type", width: "30%" },
    { text: "Срок оплаты", value: "time", width: "100px", key: 'due_date', sortable: true, align: "start" },
    { text: "Аналитика", value: "analytics", width: "12.5%" },
    { text: "Тема", value: "theme", width: "5%" },
    {
      text: "Сумма с НДС",
      value: "sumWithTax",
      width: "15%",
      align: "end",
    },
    {
      text: "Сумма без НДС",
      value: "sumWithoutTax",
      width: "15%",
      align: "end",
    },
    {
      text: "К оплате",
      value: "sumToPaid",
      width: "15%",
      align: "end",
    },
  ];

  docKeys = [
    ["тип", "номер", "дата", "документ"],
    "срок",
    "аналитика",
    "тема",
    "суммасндс",
    "суммабезндс",
    "остаток",
  ];

  humanDocTypeByValue = {
    СФ: "Реализация",
    ПЛАТ: "Входящий платеж",
    ПКО: "Приходный ордер",
  };

  allSelected = false;
  allSelectionLoading = false;
  allSelectionError = "";
  allDocuments: DocumentsByContract[] = [];
  selectedDocumentId: number | null = null;

  // Свойства, использующиеся в элементах шапки таблицы
  // (прим: расположены по порядку элементов).
  dates: string[] = [];

  docTypesBySenderStatus = ["Исходящие", "Входящие"];
  currentDocTypeBySenderStatusIndex = 0;

  docTypesByPaymentStatus = ["Все документы", "Неоплаченные"];
  currentDocTypeByPaymentStatusIndex = 1;

  public get payableDocuments(): DocumentsByContract[] {
    return this.documents.filter(document => Number(document["остаток"]) > 0);
  }

  public get earliestDocumentId(): number | null {
    // Сохраняем существующую очерёдность: сначала самый ранний неоплаченный счёт на предоплату.
    const prepayments = this.payableDocuments.filter(document => document["тип"] === "Счет на предоплату");
    const candidates = prepayments.length ? prepayments : this.payableDocuments;
    if (!candidates.length) return null;

    const ordered = [...candidates].sort((a, b) => {
      const formats = [moment.ISO_8601, "DD.MM.YYYY"];
      const dateA = moment(a["срок"] || a["дата"], formats, true);
      const dateB = moment(b["срок"] || b["дата"], formats, true);
      const aTime = dateA.isValid() ? dateA.valueOf() : Number.MAX_SAFE_INTEGER;
      const bTime = dateB.isValid() ? dateB.valueOf() : Number.MAX_SAFE_INTEGER;
      return aTime - bTime;
    });
    return Number(ordered[0]["документ"]);
  }

  public isEarliestDocument(id: number): boolean {
    return !this.allSelected && Number(id) === this.earliestDocumentId;
  }

  public isRowSelected(id: number): boolean {
    return this.allSelected
      ? this.allDocuments.some(document => Number(document["документ"]) === Number(id))
      : this.selectedDocumentId === Number(id);
  }

  public selectDocument(id: number, checked: boolean): void {
    if (this.allSelected || !this.isEarliestDocument(id)) return;
    this.selectedDocumentId = checked ? Number(id) : null;
  }

  public async toggleSelectAll(): Promise<void> {
    if (this.allSelectionLoading) return;
    if (this.allSelected) {
      this.allSelected = false;
      this.allDocuments = [];
      return;
    }

    this.allSelectionLoading = true;
    this.allSelectionError = "";
    this.selectedDocumentId = null;
    const contractId = this.contractId;
    try {
      const { data } = await appApi.fetchDocumentsByContract({
        contractId,
        type: 0,
        noPayment: 1,
        from: "",
        to: "",
        allUnpaid: true,
      });
      if (contractId !== this.contractId) return;

      const ids = new Set<number>();
      this.allDocuments = data.filter(document => {
        const id = Number(document["документ"]);
        if (!id || ids.has(id) || !(Number(document["остаток"]) > 0)) return false;
        ids.add(id);
        return true;
      });
      if (!this.allDocuments.length) {
        this.allSelectionError = "Неоплаченные счета по договору не найдены.";
        return;
      }
      this.allSelected = true;
    } catch (error) {
      this.allSelectionError = "Не удалось получить все неоплаченные счета. Повторите попытку.";
    } finally {
      this.allSelectionLoading = false;
    }
  }

  public get usePayment(): boolean {
    const { appEnviroment } = this;

    return !!(appEnviroment.constants && appEnviroment.constants["ЛКЮЛОПЛАТА"]);
  }

  /**
   * Вычисляемое свойство, значением которого является объект. Ключами такого
   * объекта являются значения свойств value объекта headers, а значениями - строки,
   * использующиеся в качестве css-классов td-элементов таблицы, что позволяет
   * определять стили для отдельного столбца. Например, для ячейки, расположенной
   * в столбце с заголовком "к оплате", будет создана следующая строка:
   * "data-table__td data-table__td_header_sum-to-paid" (см. vue-dev-tools).
   */
  public get tdClassesByHeaders() {
    const headerValues = this.headers.map(({ value }) => value);
    const tdClasses: { [headerValue: string]: string } = {};

    return headerValues.reduce((acc, headerValue) => {
      const headerId = headerValue.replace("document", "");
      let counter = 0;

      const headerIdKebabCase = headerId.replace(/[A-Z]/g, (match) => {
        const result = match.toLowerCase();
        return counter++ ? `-${result}` : result;
      });

      return {
        ...acc,
        [headerValue]: `data-table__td data-table__td_header_${headerIdKebabCase}`,
      };
    }, tdClasses);
  }

  public get totalUsedDocKeys(): number {
    return !this.currentDocTypeBySenderStatusIndex ? this.docKeys.length : 4;
  }

  public get preparedHeaders() {
    return [
      ...this.headers.slice(0, this.totalUsedDocKeys),
      { text: "", value: "action", width: "7.5%" },
    ];
  }

  public get preparedDocuments() {
    const requiredKeys = this.docKeys.slice(0, this.totalUsedDocKeys);
    let docs =  this.documents.map((document) => {
      const docValues = requiredKeys.map((keyByTd) => {
        return Array.isArray(keyByTd)
            ? keyByTd.map((key) => document[key])
            : document[keyByTd];
      });

      if (docValues[1] == null)
        docValues[1] = ''

      // Пустая строка, как последний элемент массива позволяет использовать дропдаун
      // в каждой заключительной ячейке строки таблицы.
      return [...docValues, ""];
    });

    docs = docs.sort((a: any, b: any) => {
      let dateA: any = moment(a[1]).valueOf();
      let dateB: any = moment(b[1]).valueOf();
      return dateB - dateA;
    })

    return docs;
  }

  public get currentDocTypeBySenderStatus(): string {
    return this.docTypesBySenderStatus[this.currentDocTypeBySenderStatusIndex];
  }

  public get currentDocTypeByPaymentStatus(): string {
    return this.docTypesByPaymentStatus[
      this.currentDocTypeByPaymentStatusIndex
    ];
  }

  public get allowPayment(): boolean {
    const {
      currentDocTypeBySenderStatusIndex,
      currentDocTypeByPaymentStatusIndex,
      usePayment,
    } = this;

    return !!(
      usePayment &&
      !currentDocTypeBySenderStatusIndex &&
      currentDocTypeByPaymentStatusIndex
    );
  }

  public get runUpdate(): string {
    const {
      dates,
      currentDocTypeBySenderStatusIndex,
      currentDocTypeByPaymentStatusIndex,
    } = this;

    return [
      dates.join(" - "),
      currentDocTypeBySenderStatusIndex,
      currentDocTypeByPaymentStatusIndex,
    ].join(" | ");
  }

  public get totalSelectedRows(): number {
    return this.allSelected ? this.allDocuments.length : (this.selectedDocumentId !== null ? 1 : 0);
  }

  public get selectedRowsSum(): number {
    return this.selectedDocuments.reduce(
      (totalKop, document) => totalKop + Math.round(Number(document["остаток"]) * 100),
      0
    ) / 100;
  }

  public get selectedDocuments(): DocumentsByContract[] {
    if (this.allSelected) return this.allDocuments;
    return this.payableDocuments.filter(document => Number(document["документ"]) === this.selectedDocumentId);
  }

  private openPaymentsPage(): void {
    const docs = this.selectedDocuments.map(document => ({
      счет: Number(document["документ"]),
      сумма: Math.round(Number(document["остаток"]) * 100) / 100,
    }));
    this.$router.push({
      name: "payments",
      params: {
        amount: this.selectedRowsSum.toString(),
        docs: JSON.stringify(docs),
        paymentMode: this.allSelected ? "all" : "single",
      },
    });
  }

  @Emit()
  public emitUpdateEvt() {
    const [from, to] = this.dates;

    this.$emit("update:docsProps", {
      contractId: this.contractId,
      type: this.currentDocTypeBySenderStatusIndex,
      noPayment: this.currentDocTypeByPaymentStatusIndex,
      from,
      to,
    });
  }

  @Emit()
  public propagateDocumentEvt(evtName: string, index: number, item) {
    this.$emit(evtName, item.type[3]);
  }

  /**
   * Использовать значение вычисляемого свойства runUpdate в качестве сигнала
   * для запуска события "update:docsProps". Такой vue-трюк позволяет одновременно
   * контролировать значения нескольких свойств состояния.
   */
  @Watch("runUpdate")
  public runUpdateChanged() {
    this.selectedDocumentId = null;
    this.emitUpdateEvt();
  }

  @Watch("contractId")
  public contractChanged() {
    this.selectedDocumentId = null;
    this.allSelected = false;
    this.allDocuments = [];
    this.allSelectionError = "";
  }

  @Watch("documents")
  public documentsChanged() {
    if (!this.allSelected && !this.selectedDocuments.length) {
      this.selectedDocumentId = null;
    }
  }
}

export default DocumentTable;
